import ClassicLoader from '@/components/classic-loader'
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '@/components/ui/alert-dialog'
import { SocketEvent } from '@/constants/socket-events'
import { useSocket } from '@/hooks/use-socket'
import { cn } from '@/lib/utils'
import { listWhatsappConnectionQuery } from '@/queries/whatsapp.query'
import { WhatsappService } from '@/services/whatsapp.service'
import { isSocket } from '@/utils/is-socket'
import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { toast } from 'sonner'
import { selectCurrent, selectQrCode, selectSetQrCode, useConnectionStore } from '../store'

interface ConfirmDialogProps {
  open: boolean
  onOpenChange?: (open: boolean) => void
  className?: string
}

export function ConnectionsQrCodeDialog(props: ConfirmDialogProps) {
  const {
    className,
    ...actions
  } = props;
  const qrCode = useConnectionStore(selectQrCode);
  const setQrCode = useConnectionStore(selectSetQrCode);
  const current = useConnectionStore(selectCurrent);
  const queryClient = useQueryClient();
  const { socket } = useSocket();

  async function handleCancel() {
    try {
      if (current) {
        await WhatsappService.removeConnection(current.id);
      }
      toast.info("Conexão com o whatsapp cancelada!");
    } catch (err) {
      console.error(err);
      toast.error("Ocorreu um erro ao cancelar a conexão com o whatsapp!");
    } finally {
      setQrCode(null);
      socket?.emit('leave-QrCode', { whatsappId: current?.id });
      await queryClient.invalidateQueries({ queryKey: listWhatsappConnectionQuery.queryKey });
    }
  }

  useEffect(() => {
    if (isSocket(socket) && current) {
      socket.emit(SocketEvent.JOIN_QR_CODE, { whatsappId: current.id });
    }
    return () => {
      if (isSocket(socket) && current) {
        socket.emit(SocketEvent.LEAVE_QR_CODE, { whatsappId: current.id });
      }
    }
  }, [current, socket])

  return (
    <AlertDialog {...actions}>
      <AlertDialogContent className={cn('h-[490px]', className)}>
        <AlertDialogHeader className='text-left'>
          <AlertDialogTitle>
            {qrCode ? "Escaneie o QR-Code abaixo." : "Gerando QR-Code, aguarde um momento."}
          </AlertDialogTitle>
        </AlertDialogHeader>
        {/* ========== QR Code =========== */}
        <div className="flex items-center justify-center w-full h-[300px] my-6">
          {qrCode ? (
            <img src={qrCode} alt="qr-code" className="w-max grayscale contrast-200 rounded-xl border-black" />
          ) : (
            <ClassicLoader />
          )}
        </div>
        {/* ========== Cancel connection button =========== */}
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleCancel} className='border-destructive hover:bg-destructive w-full'>
            Cancelar conexão
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
